export default __webpack_public_path__ + "static/media/Coil of the Boa.2908ae95.jpg";